import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "../static/css/modalBodega.css";

const BodegaModalAgregar = ({ show, onHide, data, setData, onSave }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Agregar Bodega</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            value={data.nombre}
                            onChange={(e) => setData({ ...data, nombre: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Dirección</Form.Label>
                        <Form.Control
                            type="text"
                            value={data.direccion}
                            onChange={(e) => setData({ ...data, direccion: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="puntoVentaCheck">
                        <Form.Check
                            type="checkbox"
                            label="¿Es punto de venta?"
                            checked={data.puntoVenta}
                            onChange={(e) =>
                                setData({ ...data, puntoVenta: e.target.checked })
                            }
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button className="btn-rosa-secondary" onClick={onHide}>
                    ❌ Cancelar
                </Button>
                <Button className="btn-rosa" onClick={onSave}>
                    💾 Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BodegaModalAgregar;
